export const ProjectStatuses = [
    { label: 'Etude de marché',     value: 'market-survey'},
    { label: 'Etude concurrents',   value: 'competitor-survey'},
    { label: 'Etude fournisseurs',  value: 'supplier-survey'},
    { label: 'Commercialisé',       value: 'marketed'},
    { label: 'Archivé',             value: 'archived'},
]



// WEBPACK FOOTER //
// ./src/config/enum/ProjectStatuses.js